<template>
  <main>
    <!-- <div class="top">
      <div class="city">
        <ul class="nav">
          <li v-for="(v, i) in city" :key="v.pids" @mouseover.stop="cityIndex = i">
            <b>{{ v.title }}</b>
            <p>
              <span v-for="s in v.hots" :key="s.id" @click="changeOption(s)">{{ s.text }}</span>
            </p>
            <i class="icon-you"></i>
          </li>
        </ul>
        <ul class="option">
          <li>
            <b class="hot">热门</b>
            <p v-if="city[cityIndex]">
              <span @click="changeOption(s)" v-for="s in city[cityIndex].hots" :key="s.id">{{ s.text }}</span>
            </p>
          </li>
          <template v-if="city[cityIndex]">
            <li v-for="v in city[cityIndex].children" :key="v.path">
              <b @click="changeOption(v)" style="cursor: pointer;">{{ v.text }}</b>
              <p>
                <span v-for="s in v.children" :key="s.id" @click="changeOption(s)">{{ s.text }}</span>
              </p>
            </li>
          </template>
</ul>
</div>
<div class="ad">
  <el-carousel class="banner">
    <el-carousel-item v-for="v in ad.banners" :key='v.id' class="banner_item">
      <router-link :to="v.url">
        <img :src="v.img" alt="">
      </router-link>
    </el-carousel-item>
  </el-carousel>
  <nav>
    <router-link v-for="v in ad.min_banners" :to="v.url" :key="v.url">
      <img :src="v.img" alt="" />
      <span>{{ v.title }}</span>
    </router-link>
  </nav>
</div>
</div> -->
    <!-- 2024-10-10 新增 旅游分类 -->
    <!-- 旅游分类 -->
    <div class="travelCategotyWrap">
      <div class="categoryTitle"><span>旅游分类</span></div>
      <div class="travelCategotyItem" v-for="item in travelCategoryList" :key="this"
        :style="{ background: item.bgColor }" @click="chooseCategoty(item)">{{
          item.title }}</div>
    </div>

    <section class="recommend">
      <h2>热门推荐</h2>
      <ul>
        <li v-for="(item, index) in hot_spus" :key="index">
          <router-link :to="'/tour/' + item.id">
            <img :src="item.cover_url" :alt="item.sub_name" />
            <figure>
              <p>{{ item.name }}</p>
              <b>{{ ConversionOtherPrice(item.starting_price) }}起</b>
            </figure>
          </router-link>
        </li>
      </ul>
    </section>

    <section class="recommend">
      <h2>优选产品</h2>
      <ul>
        <li v-for="(item, index) in optimum_spus" :key="index">
          <router-link :to="'/tour/' + item.id">
            <img :src="item.cover_url" :alt="item.sub_name" />
            <figure>
              <p>{{ item.name }}</p>
              <b>{{ ConversionOtherPrice(item.starting_price) }}起</b>
            </figure>
          </router-link>
        </li>
      </ul>
    </section>

    <!-- <section class="recommend">
      <h2>热门旅游</h2>
  
      <ul>
        <template v-for="v in ad.hots">
          <li :key="v.created_at">
            <router-link :to="v.url">
              <img :src="v.img" :alt="v.title" />
              <figure>
                <p>{{ v.title }}</p>
                <b>{{ v.min_price }}</b>
              </figure>
            </router-link>
          </li>
        </template>
      </ul>
    </section> -->



  </main>
</template>

<script>
import $tour from '@api/tour';
import tool from '@assets/js/tool';

export default {
  components: {
  },
  data() {
    return {
      cityIndex: 0,
      city: [],
      country: [
        { text: '亚洲', id: 0 },
        { text: '欧洲', id: 0 },
      ],
      countryIndex: 0,
      ad: {},
      // 以下带注释部分是  2023-08-04 添加的内容
      travelCategoryList: [],//旅游分类 
      colorList: ['#4ebeae', 'darkorange', '#87d068', '#2db7f5', 'darkorange', '#f50'],
      hot_spus: [],//热门产品
      optimum_spus: [],//优选产品
    }
  },
  computed: {
    swiper() {
      return this.$refs.swiper.$swiper
    }
  },
  async created() {
    this.getAd();

    let _this = this;
    const { TourDestinationV2: city } = await $tour.baseData();
    this.city = city;

    const baseInfo = await $tour.getTourBaseData();
    const { category, hot_spus, optimum_spus } = baseInfo.data;
    _this.hot_spus = hot_spus;
    _this.optimum_spus = optimum_spus;


    this.travelCategoryList = category;

    this.travelCategoryList.map((item, index) => {
      item.bgColor = _this.colorList[index];
    });

  },
  methods: {
    // 选择 旅游分类
    chooseCategoty(item) {
      let _this = this;
      // 跳转到 指定 分类的产品列表中去
      // _this.$router.push({ name: 'travelCategoryList', params: { category_id: item.id } });
      this.$router.push({
        path: '/travelCategoryList/' + item.id  // 假设 userId 是你要传递的参数
      });
    },
    async getAd() {
      const ad = await $tour.getAd();
      this.ad = ad;
    },
    changeOption(v) {
      const { level, path, children, id } = v;
      let res;
      switch (level) {
        case 3: {
          const list = [{ id: Number(id), text: '全部' }, ...children];
          res = { list, id };
          break;
        }
        case 4: {
          const [, , , level3ID] = path.split('-');
          const { pids, children } = this.city.find(v => v.pids.includes(level3ID));
          const i = pids.split(',').findIndex(v => v === level3ID);
          const list = [{ id: level3ID, text: '全部' }, ...children[i].children];
          res = { list, id };
          break;
        }
      }
      this.$router.push({ name: 'tour_list', params: res });
    }
  }
}
</script>

<style scoped src="./home.css"></style>